import { DialogService } from 'primeng/dynamicdialog';
import {
  FilePreviewData,
  FilePreviewModalComponent,
} from '@shared/components/file-preview-modal/file-preview-modal.component';
import { extractFileExtension, resolveFilePreviewType } from '@shared/utils/file-preview.util';

/** Payload mínimo para abrir a modal de preview: um link resolvido (URL + nome do arquivo). */
export interface FilePreviewLink {
  url: string;
  fileName: string;
}

/**
 * Abre `FilePreviewModalComponent` para um link de arquivo já resolvido (ex.:
 * `DocumentFileLinkResponse` de `accounting-document-management`, ou qualquer outro DTO com
 * `url`/`fileName`). Centraliza a configuração do `DialogService` (mesma usada em
 * `financial-statement-year-table.component.ts` do onboarding v2) para não duplicar esse objeto em
 * cada tela nova que precisar do preview — só o `DialogService` já injetado pelo chamador entra por
 * parâmetro, esta função não injeta nada.
 */
export function openFilePreviewDialog(dialogService: DialogService, link: FilePreviewLink): void {
  const extension = extractFileExtension(link.url) || extractFileExtension(link.fileName);
  const data: FilePreviewData = {
    fileName: link.fileName,
    fileUrl: link.url,
    previewType: resolveFilePreviewType(extension),
  };

  dialogService.open(FilePreviewModalComponent, {
    data,
    showHeader: false,
    modal: true,
    dismissableMask: true,
    width: '95vw',
    height: '95vh',
    styleClass: 'file-preview-dialog',
    contentStyle: { padding: '0', height: '100%', overflow: 'hidden' },
    baseZIndex: 10300,
  });
}
